import { spacing, color } from '@upstox/upstox-ui';

export const wrapper: CSSFunction = ({ theme }) => ({
  position: 'fixed',
  width: '100%',
  left: 0,
  bottom: 0,
  height: 80,
  padding: spacing(theme, ['medium']),
  backgroundColor: color(theme, 'background.default'),
  zIndex: 1,
});
export const openAccount: CSSFunction = ({ theme }) => ({
  marginRight: spacing(theme, ['medium']),
  minWidth: 156,
  color: 'inherit',
  '& a': {
    padding: spacing(theme, [18, 'xxsmall']),
  },
});
export const login: CSSFunction = ({ theme }) => ({
  minWidth: 156,
  color: 'inherit',
  '& a': {
    padding: spacing(theme, [18, 'xlarge']),
  },
});
